import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonWrapper = styled.div`
  padding: 24px;
  max-width: 600px;
  margin: 0 auto;
`;

const SkeletonHeader = styled.div`
  height: 32px;
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
  margin-bottom: 16px;
  width: 70%;
`;

const SkeletonSubheader = styled.div`
  height: 20px;
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
  margin-bottom: 24px;
  width: 90%;
`;

const SkeletonField = styled.div`
  margin-bottom: 20px;
`;

const SkeletonLabel = styled.div`
  height: 16px;
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
  margin-bottom: 8px;
  width: 30%;
`;

const SkeletonInput = styled.div`
  height: 40px;
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 4px;
  width: 100%;
`;

const SkeletonButton = styled.div`
  height: 44px;
  background: linear-gradient(to right, #f0f0f0 8%, #f5f5f5 18%, #f0f0f0 33%);
  background-size: 800px 100px;
  animation: ${shimmer} 1.5s linear infinite;
  border-radius: 22px;
  margin-top: 24px;
  width: 120px;
  margin-left: auto;
  margin-right: auto;
`;

const FormSkeletonLoader = () => {
  return (
    <SkeletonWrapper>
      <SkeletonHeader />
      <SkeletonSubheader />

      {/* Student name placeholder */}
      <SkeletonField>
        <SkeletonInput
          style={{ width: '60%', margin: '0 auto', marginBottom: '12px' }}
        />
      </SkeletonField>

      {/* School key placeholder */}
      <SkeletonField>
        <SkeletonInput
          style={{ width: '40%', margin: '0 auto', marginBottom: '24px' }}
        />
      </SkeletonField>

      {/* Form fields */}
      <SkeletonField>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonField>

      <SkeletonField>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonField>

      <SkeletonField>
        <SkeletonLabel style={{ width: '35%' }} />
        <SkeletonInput />
      </SkeletonField>

      <SkeletonButton />
    </SkeletonWrapper>
  );
};

export default FormSkeletonLoader;
